// extracted by mini-css-extract-plugin
module.exports = {"editorStructure":"PageWithSidebarStructureWithPoints_editorStructure__KsbVv","topPoints":"PageWithSidebarStructureWithPoints_topPoints__3KBbC"};